module.exports = __webpack_public_path__ + "static/media/publish_modules_prac.01871bb8.svg";